<template>
    <div class="col-md-12 mb-4 d-sm-block">
        <div class="limited-width-lg">
            <div class="services-list">
                <div class="pr-3">
                    <h2 class="color-teal-base text-uppercase mb-4">{{ translate.login.offeringServicesFeatures }}</h2>
                    <ul class="list-unstyled mb-0">
                        <li>{{ translate.login.registerSeekingText1 }}</li>
                        <li>{{ translate.login.registerSeekingText2 }}</li>
                        <li>{{ translate.login.registerSeekingText3 }}</li>
                        <li>{{ translate.login.registerSeekingText4 }}</li>
                    </ul>
                </div>
                <div class="pl-3">
                    <h2 class="color-teal-base text-uppercase mb-4">{{ translate.login.seekingServicesFeatures }}</h2>
                    <ul class="list-unstyled mb-0">
                        <li>{{ translate.login.registerOfferingText1 }}</li>
                        <li>{{ translate.login.registerOfferingText2 }}</li>
                        <li>{{ translate.login.registerOfferingText3 }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    computed: {
        ...mapState(['translate']),
    }
}
</script>
